import { useQuery } from "@tanstack/react-query";
import { axiosClient } from "@/lib/axiosClient";

export interface LookupOption {
    id: number;
    name: string;
}

interface ReligionRecord {
    religion_id: number;
    name: string;
}

interface CountryRecord {
    country_id: number;
    name: string;
}

export const useReligions = () => {
    return useQuery<LookupOption[]>({
        queryKey: ["religions"],
        queryFn: async () => {
            const { data } = await axiosClient.get<ReligionRecord[]>("/religions", { withCredentials: true });
            return data.map((r) => ({ id: r.religion_id, name: r.name }));
        },
        staleTime: 1000 * 60 * 60,
    });
};

export const useCountries = () => {
    return useQuery<LookupOption[]>({
        queryKey: ["countries"],
        queryFn: async () => {
            const { data } = await axiosClient.get<CountryRecord[]>("/countries", { withCredentials: true });
            return data.map((c) => ({ id: c.country_id, name: c.name }));
        },
        staleTime: 1000 * 60 * 60,
    });
};
